import { render, staticRenderFns } from "./Citas.vue?vue&type=template&id=0e81968e&scoped=true"
import script from "./Citas.vue?vue&type=script&lang=js"
export * from "./Citas.vue?vue&type=script&lang=js"
import style0 from "./Citas.vue?vue&type=style&index=0&id=0e81968e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e81968e",
  null
  
)

export default component.exports